import {
  EffectCallback,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import moment from "moment";

export const useTimer = () => {
  const [time, setTime] = useState(moment().format());
  const tick = () => setTime(moment().format());
  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });
  return time;
};

export const usePrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useInterval = (
  callback: EffectCallback,
  delay: number,
): MutableRefObject<number> => {
  const intervalRef = useRef<number>();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (typeof delay === "number") {
      intervalRef.current = window.setInterval(
        () => callbackRef.current(),
        delay,
      );
      return () => window.clearInterval(intervalRef.current);
    }
  }, [delay]);

  return intervalRef;
};
